export default __webpack_public_path__ + "static/media/juniper.6b262087.png";